import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { UserReducer } from './user_reducer';
import { GlobalSearchReducer } from './globalSearch_reducer';
import loaderReducer from './slices/loaderSlice';
import vendorReducer from './slices/vendorSlice';
import uiReducer from './slices/uiSlice';
import chatbotReducer from './slices/chatbotSlice';
import formReducer from './slices/formSlice';
import reasonCatalogReducer from './slices/reasonCatalogSlice';
export const Reducer = combineReducers({
    loader: loaderReducer,
    vendor: vendorReducer,
    ui: uiReducer,
    chatbot: chatbotReducer,
    form: formReducer,
    reasonCatalog: reasonCatalogReducer,
    User: UserReducer,
    GlobalSearch: GlobalSearchReducer,
});
export const persistConfig = {
    key: 'root',
    timeout: 0,
    storage,
    whitelist: ['vendor', 'User', 'reasonCatalog'],
    blacklist: [],
};
